module.exports = __webpack_public_path__ + "img/mD-badge1-light.748b14bf.png";